import { api } from './client';

export const workoutsAPI = {
  list: (params) => api.get('/workouts/', { params }),
  get: (id) => api.get(`/workouts/${id}/`),
  create: (data) => api.post('/workouts/', data),
  downgrade: (id, payload) => api.post(`/workouts/${id}/downgrade/`, payload),
  update: (id, data) => api.patch(`/workouts/${id}/`, data),
  delete: (id) => api.delete(`/workouts/${id}/`),
  recalculate: (id) => api.post(`/workouts/${id}/recalculate/`),
  setShoe: (id, shoe) => api.patch(`/workouts/${id}/`, { shoe }),
  swapWorkoutDays: (date1, date2) => api.post('/workouts/swap-days/', { date1, date2 }),
  complete: (id, data) => api.patch(`/workouts/${id}/`, { is_completed: true, ...data }),
};

export const workoutIntervalsAPI = {
  update: (id, payload) => api.patch(`/workout-intervals/${id}/`, payload),
};

export const trainingJournalAPI = {
  get: (params) => api.get('/training-journal/', { params }),
};